import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { EnvironmentService } from '../environment.service';
import { IGridService } from '../models/igrid-service';
import { PrixListResult } from '../models/prix-list';
import { PrixDto } from '@lexi-clients/lexi';

@Injectable({
  providedIn: 'root'
})
export class PrixListService implements IGridService<PrixDto> {
  baseUrl: string;

  constructor(private http: HttpClient, envService: EnvironmentService) {
    this.baseUrl = envService.environment.baseServiceUrl;
  }

  get(params: HttpParams): Observable<PrixListResult> {
    return this.http.get<any>(`${this.baseUrl}/api/Prix/rechercher`, { params: params });
  }

  getById(id: number): Observable<PrixDto> {
    return this.http.get<any>(`${this.baseUrl}/api/Prix/${id}`);
  }

  post(valeur: PrixDto): Observable<any> {
    return null;
  }

  put(valeur: PrixDto): Observable<any> {
    return null;
  }

  delete(valeur: PrixDto): Observable<any> {
    return null;
  }
}
